import { useTranslation } from 'react-i18next'
import Button from '../../../components/ui/Button'
import type { DeadlineRequest } from '../types'

interface Props {
  row: DeadlineRequest
  onApprove: (row: DeadlineRequest) => void
  onReject: (row: DeadlineRequest) => void
  /** İşlem süren satır — yalnız o satırın butonları kilitlenir (078-b `busyId` deseni). */
  busy: boolean
}

/**
 * Satır işlemleri — Onayla/Reddet **doğrudan buton** olarak çıkar (kullanıcı kararı 2026-08-21):
 * önceki kebab (3 nokta) menüsü kararı ekstra bir tıklama gerektiriyordu, kullanıcı bunu menü gibi
 * değil doğrudan görünür buton istedi. `admin-row-actions` deseni (ör. `RoleColumns`) izlenir: kısa,
 * ikon-only, `rounded text`, tooltip + `aria-label` ile.
 *
 * <p><b>`severity` verilmez:</b> `primereact-overrides.css` "TEXT — nötr gri, asla kırmızı değil"
 * kuralıyla tüm `text` varyantı butonları severity'den bağımsız nötr griye sabitler — Onayla/Reddet
 * yeşil/kırmızı ikon rengiyle ayrışmaz, ikon (`pi-check`/`pi-times`) ve tooltip ayrımı yeterlidir.
 *
 * <p>Bu bileşen yalnız {@link DeadlineRequest.canDecide} olan satırda render edilir — bayrağı
 * <b>sunucu</b> hesaplar; istemci yetki kuralını yeniden hesaplamaz. Karar hakkı yoksa boş bir hücre
 * bırakmak yerine hücre tamamen boş kalır (basılamayacak kontrol gösterilmez).
 *
 * <p><b>Neden ayrı dosya:</b> `DeadlineRequestColumns.tsx` bileşen değil <b>fonksiyon</b> (kolon
 * dizisi) ihraç ediyor; bir bileşeni onun yanına koymak `react-refresh/only-export-components`
 * uyarısı üretiyordu.
 */
export default function DeadlineRequestRowActions({ row, onApprove, onReject, busy }: Readonly<Props>) {
  const { t } = useTranslation()

  return (
    <span className="dr-row-actions">
      <Button
        type="button"
        rounded
        text
        icon="pi pi-check"
        aria-label={t('deadlineRequests.approve.action')}
        tooltip={t('deadlineRequests.approve.action')}
        tooltipOptions={{ position: 'bottom' }}
        disabled={busy}
        onClick={() => onApprove(row)}
      />
      <Button
        type="button"
        rounded
        text
        icon="pi pi-times"
        aria-label={t('deadlineRequests.reject.action')}
        tooltip={t('deadlineRequests.reject.action')}
        tooltipOptions={{ position: 'bottom' }}
        disabled={busy}
        onClick={() => onReject(row)}
      />
    </span>
  )
}
